export default __webpack_public_path__ + "static/media/Dice-2.22ae962e.png";